import type { SetupState } from '../types/setup';

export const mockPipelineSetup: SetupState = {
  numberOfPipeSizes: 2,
  pipeSizes: [
    {
      size: '24.0',
      wallThickness: '0.75',
      buckleArrestors: '0',
      numberOfPipes: '50',
      pipeLength: '12.5',
      numberOfForges: '0',
      outputAssemblyLength: '0',
      manufacturer: 'Manufacturer A'
    },
    {
      size: '36.0',
      wallThickness: '1.0',
      buckleArrestors: '0',
      numberOfPipes: '30',
      pipeLength: '12.5',
      numberOfForges: '0',
      outputAssemblyLength: '0',
      manufacturer: 'Manufacturer B'
    }
  ],
  manufacturers: ['Manufacturer A', 'Manufacturer B', 'Manufacturer C'],
  isAddingManufacturer: false,
  newManufacturer: '',
  isSaving: false
}; 